// extracted by mini-css-extract-plugin
export default {"container":"src-components-DragContainers-LeftGreenBlock-css__container--lFN9K","greenBlock":"src-components-DragContainers-LeftGreenBlock-css__greenBlock--P56Zr"};